/*
 * Public API Surface of ngx-ssr-exclude
 */

export * from './lib/ngx-ssr-exclude.module';
